import React, { useState } from "react";
import "../../page_content.css";
import Accordion from "../../../components/reuseable_comp/accordion/Accordion";

const Training = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <h1  className="title">Placement Training</h1>
      <hr />
      <div className="page-content-container">
        <p>
          MANET Training and Placement (T and P) department works on two
          segments of training: Technical and Non-technical
        </p>

        {/* accordion */}
        <Accordion
          title="Technical Training"
          isActive={activeIndex === 0}
          onClick={() => handleToggle(0)}
        />
        {activeIndex === 0 && (
          <div className="accordion-content">
            <p>
              Technical training is carried out in regular course (B. Tech &
              B.Sc.). The technical knowledge acquired by the cadets is assessed
              by conducting mock interviews. The mock interviews are conducted
              by internal as well as external subject experts. The cadets are
              assessed with multiple parameters, and the analysis report is
              shared with the cadets for focusing on areas for further
              improvement.
            </p>
            <ul className="page-content-lists ">
              <li>
                Training is imparted to the cadets on Awareness on the M.S.
                (Recruitment and Placement of Seafarers Rules 2005) as per the
                DG Shipping requirement.
              </li>
              <li>
                Training and Placement Manual includes all the necessary
                information regarding selection process, grooming for
                interviews, company criteria & technical questionnaire.
              </li>
              <li>
                Cadets are briefed about placement drives and prerequisites by
                conducting meetings (online/offline).
              </li>
              <li>
                Cadets undergo 4G welding course which enhances their placement
                prospects.
              </li>
            </ul>
          </div>
        )}

        <Accordion
          title="Non-Technical Training"
          isActive={activeIndex === 1}
          onClick={() => handleToggle(1)}
        />
        {activeIndex === 1 && (
          <div className="accordion-content">
            <div className="accordion-content">
              <p>
                Non-Technical segment is handled by School of Corporate
                Innovation and Leadership (SCIL) in collaboration with MANET
                Training and Placement department. SCIL is one of the youngest
                additions to MIT ADT University's bouquet of offerings for
                profound development of i Gen. It works in coordination with
                MANET Training and Placement department with the mission "To
                provide cadets with the platform where they can learn and
                enhance their skills to be employable". It has three major
                drives:
              </p>
              <ul className="page-content-lists ">
                <li>Development of cadet professional capabilities</li>
                <li>Corporate executive education</li>
                <li>Most innovative multidisciplinary programs.</li>
              </ul>
            </div>
          </div>
        )}

        <Accordion
          title="Professional & Aptitude Skills"
          isActive={activeIndex === 2}
          onClick={() => handleToggle(2)}
        />
        {activeIndex === 2 && (
          <div className="accordion-content">
            <div className="accordion-content">
              <p>
                Department is delicately working to achieve this mission with
                most dedicated and committed faculty members. The core areas of
                practices include Professional Skills, Aptitude skills and
                Career Advancements.
              </p>
              <ul className="page-content-lists ">
                <li>
                  Professional Skills Domain handles areas like Professional
                  Soft Skills, Behavioral Skills and Employability Enhancement
                  Skills.
                </li>
                <li>
                  Competitive Aptitude domain handles areas like Quantitative
                  Aptitude, Logical Reasoning and Verbal Ability which are
                  helpful during the Placement process.
                </li>
                <li>
                  Career Advancements conduct activity during seventh and fifth
                  semester of B. Tech and B.Sc. respectively.
                </li>
              </ul>
              <p>
                Manifestation of these skills happens through the cadets
                participation in Group Discussion (GD) and Personal Interviews
                (PI) drives that are conducted most effectively by SCIL faculty
                members along with technical domain experts (Internal and
                external) having vast maritime industry experience.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Training;
